<template>
  <template-list :type="'editor'" :columnsData="columnsData" />
</template>
<script>
import TemplateList from '../layout/TemplateList';
import store from '../../store/index';

export default {
  name: 'editor-list',
  components: {
    TemplateList,
  },
  data() {
    return {
      columnsData: [
        'title',
        'original_oem',
        'frame_type',
        'model',
        'part_number',
        'location',
        'document_number',
        'revision',
      ],
    };
  },
  async beforeRouteEnter({}, from, next) {
    const { state } = store;

    const urlPathSplitted = from.path.split('/');

    if (urlPathSplitted.length === 4) {
      const jobId = urlPathSplitted[3];
      if (jobId && jobId !== 'create') {
        await store.dispatch('processJobChanges', jobId);
      }
    }

    state.job = null;

    next();
  },
};
</script>
